export enum TokenType {
    PASSWORD_RESET = 'PASSWORD_RESET',
    EMAIL_VERIFICATION = 'EMAIL_VERIFICATION',
    CHECKOUT_RETURN = 'CHECKOUT_RETURN',
}
